// extracted by mini-css-extract-plugin
export default {"wrap":"VF-z","fullWidth":"WF-z","hideOnDesktop":"XF-z","content":"YF-z","hasOpenedNav":"ZF-z","crumbsList":"_F-z","dropdownsWrap":"aG-z"};